import { TICKETS_DATA, TICKETS_ERROR, TICKETS_HIDE_ERROR, TICKETS_START_LOADER, TICKETS_STOP_LOADER, } from "../interface/TicketsData";
const initialState = {
    data: {},
    ticketsLoader: false,
    errorData: {
        error: null,
        isOpen: false,
    },
};
const TicketsReducer = (state = initialState, action) => {
    switch (action.type) {
        case TICKETS_DATA:
            return Object.assign(Object.assign({}, state), { data: action.payload.data });
        case TICKETS_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: action.payload.errorData });
        case TICKETS_HIDE_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: initialState.errorData });
        case TICKETS_START_LOADER:
            return Object.assign(Object.assign({}, state), { ticketsLoader: true });
        case TICKETS_STOP_LOADER:
            return Object.assign(Object.assign({}, state), { ticketsLoader: false });
        default:
            return Object.assign({}, state);
    }
};
export default TicketsReducer;
